import type { StoryTemplate } from 'schemas';
import { StoryTemplateResponseSchema } from 'schemas';
import { apiRequest } from '@/api/helpers/apiRequest';
import { handleApiError } from '@/api/helpers/handleApiError';

export const fetchStoryTemplate = async (
  templateId: string
): Promise<StoryTemplate> => {
  try {
    return await apiRequest(
      'GET',
      `/api/story-templates/${templateId}`,
      undefined,
      StoryTemplateResponseSchema
    );
  } catch (error) {
    handleApiError(error);
  }
};
